import {createGlobalState} from 'react-hooks-global-state';


const {setGlobalState, useGlobalState} = createGlobalState({
    "Okay": null,
    "ErrorMessage": null,
    "ErrorCode": null,
    "StudentKey": null,
    "FirstName": null,
    "LastName": null,
    "FullName": null,
    "authtoken": null,
    "DistrictID": null,
    "HideTeksTracker": null,
    "SEAccessReadOnly": false
})

export {useGlobalState,setGlobalState}